export enum FaxCoverSheetClickableTextContext {
    Subject,
    Message
}
